export default __webpack_public_path__ + "static/media/ico_card.b6db53b6.svg";